import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  MotifLabel,
  MotifFormField,
  MotifInput,
  MotifSelect,
  MotifOption,
  MotifFileUploader,
  MotifFileUploaderItem,
  MotifIcon,
  MotifErrorMessage,
} from "@/libs/@ey-xd/motif-react";
import { MotifActionIcDescription24px } from "@ey-xd/motif-icon";
import { AttributeType } from "@/pages/CaseDetail/Configuration/Attributes/type";
import {
  CustomAttributeFormats,
  CustomAttributeProps,
} from "./CustomAttributeType";
import "./CustomAttribute.css";
import FormattedDatePicker from "../FormattedDatePicker/FormattedDatePicker";
import { fileExtensions } from "@/services/documents/documentsReducer";
import CustomMaskedInput from "./CustomMaskedInput";
import CommonTooltipWrapper from "../Tooltip/CommonTooltipWrapper";
import helpCircleImg from "@/features/caselist/images/help-circle.svg";
import { dateFunc } from "../Functions/dateFunc";

export default function CustomAttribute({
  customAttributeDetails,
  customAttributeType,
  attributeValue,
  setAttributeValue,
  index,
  setIntialAttributesValue,
  disabled,
  errorFields,
  setErrorFields,
  showAttributesWithValue = false,
  variant = "create",
}: CustomAttributeProps) {
  const { t } = useTranslation();
  const [valid, setValid] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  // check for value formate when spaces or dashes are included i.e "xxx xxx xxx" or "xxx-xxx-xxx"
  // function checkSpecialCharactersAccornce(value: any) {
  //   let flag = false;
  //   let specialCharacterOccurance = "";
  //   for (var i = 0; i < value.length; i = i + 4) {
  //     if (i < 3) {
  //       if (value[i + 3] !== " " && value[i + 3] !== "-") {
  //         flag = true;
  //         break;
  //       }
  //       specialCharacterOccurance = value[i + 3];
  //     } else if (i > 3) {
  //       if (
  //         value?.[i + 3] !== specialCharacterOccurance &&
  //         value[i + 3] !== undefined
  //       ) {
  //         flag = true;
  //         break;
  //       }
  //     }
  //     let partOfString = value.substring(i, i + 3);
  //     if (partOfString.includes(" ") || partOfString.includes("-")) {
  //       flag = true;
  //     }
  //   }
  //   return flag;
  // }
  // function sinNumberValidation(value: any) {
  //   //A valid Canada SIN is a 9-digit number
  //   let removespacesanddashes = value?.replace(/[- ]/g, "");
  //   if (removespacesanddashes?.length !== 9) return false;
  //   if (
  //     value?.[value.length - 1] === " " ||
  //     value?.[value.length - 1] === "-"
  //   ) {
  //     return false;
  //   }
  //   if (value?.includes("-") || value?.includes(" ")) {
  //     if (checkSpecialCharactersAccornce(value)) {
  //       return false;
  //     }
  //   }

  //   // accept only digits, dashes or spaces
  //   if (/[^0-9-\s]+/.test(value)) return false;

  //   // The Luhn Algorithm.
  //   let nCheck = 0;
  //   let nDigit = 0;
  //   let bEven = false;
  //   value = value?.replace(/\D/g, "");

  //   for (let n = value.length - 1; n >= 0; n--) {
  //     let cDigit = value.charAt(n);
  //     nDigit = parseInt(cDigit, 10);
  //     if (bEven) {
  //       if ((nDigit *= 2) > 9) nDigit -= 9;
  //     }

  //     nCheck += nDigit;
  //     bEven = !bEven;
  //   }

  //   return nCheck % 10 === 0;
  // }
  function handleRegexValidation(value: string, regexPattern?: string) {
    let valueReg = regexPattern || "";
    if (valueReg.startsWith("/")) {
      valueReg = valueReg.slice(1, -1);
    }
    if (valueReg.endsWith("/")) {
      valueReg = valueReg.slice(1);
    }
    let regexexp = new RegExp(valueReg);

    return regexexp.test(value);
  }
  useEffect(() => {
    if (
      customAttributeDetails.metadataJSON?.default &&
      customAttributeDetails.metadataJSON.default !== "" &&
      attributeValue &&
      variant !== "edit"
    ) {
      if (
        customAttributeType === AttributeType.Boolean &&
        attributeValue[index].value.booleanValue === null
      ) {
        if (customAttributeDetails.metadataJSON?.default === "true") {
          handleDefaultChange(true);
        } else {
          handleDefaultChange(false);
        }
      } else {
        if (customAttributeDetails.picklistDefinitions) {
          const optionId = customAttributeDetails.picklistDefinitions.filter(
            (x: any) => {
              return x.name === customAttributeDetails.metadataJSON?.default;
            }
          );
          if (optionId.length !== 0) {
            if (
              customAttributeType === AttributeType.SingleSelect &&
              attributeValue[index].value.selectedValue === null
            ) {
              handleDefaultChange(optionId[0].id);
            } else if (
              customAttributeType === AttributeType.MutliSelect &&
              attributeValue[index].value.selectedValues.length === 0
            ) {
              handleDefaultChange([optionId[0].id]);
            }
          }
        }
      }
    }
    // eslint-disable-next-line
  }, []);
  function handleAttributeValues(prev: any, value: any) {
    const updatedValue = prev?.map((x: any, i: any) => {
      if (i === index) {
        switch (customAttributeType) {
          case AttributeType.Boolean:
            return { ...x, value: { ...x.value, booleanValue: value } };
          case AttributeType.SingleSelect:
            return { ...x, value: { ...x.value, selectedValue: value } };
          case AttributeType.MutliSelect:
            return { ...x, value: { ...x.value, selectedValues: value } };
          default:
            return x;
        }
      } else {
        return x;
      }
    });
    return updatedValue;
  }

  const handleDefaultChange = (value: any) => {
    setAttributeValue((prev: any) => {
      return handleAttributeValues(prev, value);
    });
    if (setIntialAttributesValue) {
      setIntialAttributesValue((prev: any) => {
        return handleAttributeValues(prev, value);
      });
    }
  };

  const validateValue = (value: any) => {
    if (customAttributeDetails.isRequired && value === "") {
      setErrorMessage(
        customAttributeDetails.name +
          " " +
          t("pages.configuration.attributes.requiredError")
      );
      return false;
    } else {
      switch (customAttributeType) {
        case AttributeType.Number:
          if (
            customAttributeDetails.metadataJSON?.minimum !== undefined &&
            customAttributeDetails.metadataJSON?.maximum !== undefined
          ) {
            setErrorMessage(
              t("pages.configuration.attributes.numberError") +
                customAttributeDetails.metadataJSON.minimum +
                " & " +
                customAttributeDetails.metadataJSON.maximum
            );
            return (
              Number(value) >=
                Number(customAttributeDetails.metadataJSON.minimum) &&
              Number(value) <=
                Number(customAttributeDetails.metadataJSON.maximum)
            );
          }
          return true;

        case AttributeType.FreeText:
          switch (customAttributeDetails.metadataJSON?.format) {
            // case CustomAttributeFormats.SIN:
            //   if(sinNumberValidation(value?.toString())){
            //     setErrorMessage(
            //       customAttributeDetails.name + "is not a valid sin number")
            //   }

            //   return value.match(/^\d{9}$/);

            case CustomAttributeFormats.Email:
              setErrorMessage(t("pages.configuration.attributes.emailError"));
              // eslint-disable-next-line
              return value.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/);

            // case CustomAttributeFormats.Regex:
            //   try {
            //     setErrorMessage(t("pages.configuration.attributes.regexError"));
            //     return value.match(
            //       new RegExp("") //Need to add user inputted Regex here
            //     );
            //   } catch (e) {
            //     return true;
            //   }

            case CustomAttributeFormats.Phone:
              setErrorMessage(
                customAttributeDetails.name +
                  " " +
                  t("pages.configuration.attributes.phoneError")
              );
              return value.match(
                /^(\d{3}-?\s?\d{3}-?\s?\d{4}\s?)?(ext\.\d{4})?$/
              );

            case CustomAttributeFormats.Postal:
              setErrorMessage(
                customAttributeDetails.name +
                  " " +
                  t("pages.configuration.attributes.postalError")
              );
              return value.match(/^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/);

            default:
              return true;
          }

        default:
          return true;
      }
    }
  };

  const handleChange = (value: any, name?: string) => {
    const filterFields = errorFields?.filter((x: any) => x !== name);
    if (filterFields && setErrorFields) {
      setErrorFields(filterFields);
    }
    const updatedValue = attributeValue.map((x: any, i: any) => {
      if (i === index) {
        switch (customAttributeType) {
          case AttributeType.FreeText:
            return { ...x, value: { ...x.value, textValue: value } };
          case AttributeType.Number:
            return { ...x, value: { ...x.value, numberValue: value } };
          case AttributeType.Boolean:
            return { ...x, value: { ...x.value, booleanValue: value } };
          case AttributeType.Date:
            return { ...x, value: { ...x.value, dateValue: value } };
          case AttributeType.SingleSelect:
            return {
              ...x,
              value: { ...x.value, selectedValue: value || null },
            };
          case AttributeType.MutliSelect:
            return { ...x, value: { ...x.value, selectedValues: value } };
          case AttributeType.Currency:
            return { ...x, value: { ...x.value, amount: value } };
          case AttributeType.Document:
            return { ...x, value: { ...x.value, displayName: value } };
          default:
            return x;
        }
      } else {
        return x;
      }
    });

    setAttributeValue(updatedValue);
    setValid(validateValue(value));
  };

  const handleFileChange = (files: any) => {
    const file = files[0];
    if (file) {
      handleChange(file.name, customAttributeDetails.name);

      const fileType = file.name.split(".").pop();
      if (
        customAttributeDetails.metadataJSON?.fileFormat !== undefined &&
        customAttributeDetails.metadataJSON.fileFormat !== ""
      ) {
        setErrorMessage(t("pages.configuration.attributes.fileError"));
        setValid(
          customAttributeDetails.metadataJSON.fileFormat!.includes(fileType)
        );
      }
    }
  };
  function stopAutoFilling() {
    //this function is used to stop auto filling of password fields
    return (
      <MotifInput
        //@ts-ignore
        autoComplete="new-password"
        style={{ display: "none" }}
        type="password"
      ></MotifInput>
    );
  }
  const renderField = () => {
    switch (customAttributeType) {
      case AttributeType.FreeText:
        return customAttributeDetails.metadataJSON?.maskInput ? (
          <>
            <CustomMaskedInput
              disabled={disabled}
              value={
                attributeValue[index].value.textValue
                  ? attributeValue[index].value.textValue
                  : ""
              }
              onChange={(value: any) =>
                handleChange(value, customAttributeDetails.name)
              }
              maxLength={
                customAttributeDetails.metadataJSON?.maxCharacter || 100
              }
              fieldFocus={errorFields?.includes(customAttributeDetails.name)}
            ></CustomMaskedInput>
          </>
        ) : (
          <MotifInput
            disabled={disabled ? disabled : false}
            value={
              attributeValue[index].value.textValue
                ? attributeValue[index].value.textValue
                : ""
            }
            onChange={(e) =>
              handleChange(e.target.value, customAttributeDetails.name)
            }
            type={
              customAttributeDetails.metadataJSON?.maskInput
                ? "password"
                : "text"
            }
            hideClearButton={customAttributeDetails.metadataJSON?.maskInput}
            maxLength={customAttributeDetails.metadataJSON?.maxCharacter || 100}
          />
        );

      case AttributeType.SingleSelect:
        if (customAttributeDetails.picklistDefinitions?.length === 0) {
          return (
            <MotifErrorMessage>
              <i>
                {t(
                  "pages.configuration.attributes.createAttribute.missingConfig"
                )}
              </i>
            </MotifErrorMessage>
          );
        }
        return (
          <MotifSelect
            disabled={disabled ? disabled : false}
            value={
              attributeValue[index].value.selectedValue
                ? attributeValue[index].value.selectedValue
                : ""
            }
            className="select-input-custom-attribute"
            onChange={(value) =>
              handleChange(value, customAttributeDetails.name)
            }
            triggerButtonProps={{ type: "button" }}
          >
            <MotifOption value="" key="default-one">
              {t("global.globalActions.selectOption")}
            </MotifOption>
            {customAttributeDetails &&
              customAttributeDetails.picklistDefinitions &&
              customAttributeDetails.picklistDefinitions.length > 0 &&
              customAttributeDetails.picklistDefinitions.map(
                (option: any, index: number) => (
                  <MotifOption value={option.id} key={index}>
                    {option.name}
                  </MotifOption>
                )
              )}
          </MotifSelect>
        );

      case AttributeType.MutliSelect:
        if (customAttributeDetails.picklistDefinitions?.length === 0) {
          return (
            <MotifErrorMessage>
              <i>
                {t(
                  "pages.configuration.attributes.createAttribute.missingConfig"
                )}
              </i>
            </MotifErrorMessage>
          );
        }
        return (
          <MotifSelect
            disabled={disabled ? disabled : false}
            value={
              attributeValue[index].value.selectedValues
                ? attributeValue[index].value.selectedValues
                : ""
            }
            className="select-input-custom-attribute"
            onChange={(value) =>
              handleChange(value, customAttributeDetails.name)
            }
            multiple={true}
            triggerButtonProps={{ type: "button" }}
          >
            {customAttributeDetails.picklistDefinitions?.length !== 0 &&
              customAttributeDetails.picklistDefinitions?.map(
                (option: any, index: number) => (
                  <MotifOption value={option.id} key={index}>
                    {option.name}
                  </MotifOption>
                )
              )}
          </MotifSelect>
        );

      case AttributeType.Boolean:
        return (
          <MotifSelect
            disabled={disabled ? disabled : false}
            value={
              attributeValue[index].value.booleanValue !== null &&
              attributeValue[index].value.booleanValue !== undefined
                ? attributeValue[index].value.booleanValue.toString()
                : ""
            }
            onChange={(value) => {
              if (value === "true") {
                handleChange(true, customAttributeDetails.name);
              } else {
                handleChange(
                  value === "" ? null : false,
                  customAttributeDetails.name
                );
              }
            }}
            triggerButtonProps={{ type: "button" }}
            className="select-input-custom-attribute"
          >
            <MotifOption value={""}>
              {t("global.globalPlaceholder.pleaseSelect")}
            </MotifOption>
            <MotifOption value="true">
              {t("pages.configuration.attributes.createAttribute.yes")}
            </MotifOption>
            <MotifOption value="false">
              {t("pages.configuration.attributes.createAttribute.no")}
            </MotifOption>
          </MotifSelect>
        );

      case AttributeType.Number:
        return (
          <MotifInput
            disabled={disabled ? disabled : false}
            value={
              attributeValue[index].value.numberValue ||
              attributeValue[index].value.numberValue === 0
                ? attributeValue[index].value.numberValue
                : ""
            }
            onChange={(e) => {
              if (
                customAttributeDetails.metadataJSON?.format ===
                  CustomAttributeFormats.Integer &&
                /\./.test(e.target.value)
              ) {
                e.preventDefault();
                return;
              }
              let rgrx =
                customAttributeDetails.metadataJSON?.format ===
                CustomAttributeFormats.Integer
                  ? /^-?\d*$/
                  : /^-?\d*\.?\d*$/;
              if (!rgrx.test(e.target.value)) return;

              handleChange(
                e.target.value || e.target.value === "0"
                  ? e.target.value
                  : null,
                customAttributeDetails.name
              );
            }}
            type="text"
            maxLength="100"
            onKeyPress={(e: any) => {
              if (
                (customAttributeDetails.metadataJSON?.format ===
                  CustomAttributeFormats.Integer &&
                  /\./.test(e.key)) ||
                e.key === "e"
              ) {
                e.preventDefault();
              }
            }}
          />
        );

      case AttributeType.Document:
        return (
          <MotifFileUploader
            disabled={disabled ? disabled : false}
            label="Drag and drop a document or upload"
            accept={customAttributeDetails.metadataJSON?.fileFormat}
            onDrop={(files) => handleFileChange(files)}
            maxFiles={1}
          >
            {attributeValue[index].value.documentId && (
              <MotifFileUploaderItem
                fileIcon={<MotifIcon src={MotifActionIcDescription24px} />}
                fileName={
                  attributeValue[index].value.displayName
                    ? attributeValue[index].value.displayName
                    : ""
                }
                onRemove={() => setAttributeValue(null)}
                removable
                error={
                  (attributeValue[index].value &&
                    attributeValue[index].value?.size >=
                      fileExtensions.maxFileSize) ||
                  false
                }
                errorText={t(
                  "pages.claims.stageStatusPopup.filesizeExceedsLimit",
                  {
                    filesize: "250",
                  }
                )}
              />
            )}
          </MotifFileUploader>
        );

      case AttributeType.Date:
        return (
          <FormattedDatePicker
            disabled={disabled ? disabled : false}
            onChange={(value) => {
              handleChange(value, customAttributeDetails.name);
            }}
            value={
              attributeValue[index].value.dateValue
                ? dateFunc(attributeValue[index].value.dateValue)
                    .formattedDateOnly
                : undefined
            }
            todayMark={true}
          />
        );

      case AttributeType.Currency:
        return (
          <MotifInput
            disabled={disabled ? disabled : false}
            value={
              attributeValue[index].value.amount ||
              attributeValue[index].value.amount === 0
                ? attributeValue[index].value.amount
                : ""
            }
            onChange={(e) => {
              if (!/^-?\d*\.?\d*$/.test(e.target.value)) return;
              handleChange(
                e.target.value || e.target.value === "0" ? e.target.value : "",
                customAttributeDetails.name
              );
            }}
            type="text"
            maxLength="100"
            onKeyPress={(e: any) => {
              if (e.key === "e") {
                e.preventDefault();
              }
            }}
          />
        );

      default:
        return <></>;
    }
  };
  const returnValue = (
    attributeType: any,
    value: any,
    picklistDefinitions: any
  ) => {
    switch (attributeType) {
      case AttributeType.FreeText:
        return value.textValue ? value.textValue : undefined;
      case AttributeType.Number:
        return value.numberValue || value.numberValue === 0 ? true : undefined;
      case AttributeType.Boolean:
        if (value.booleanValue === null) {
          return undefined;
        } else {
          if (value.booleanValue) {
            return t("pages.configuration.attributes.createAttribute.yes");
          } else {
            return t("pages.configuration.attributes.createAttribute.no");
          }
        }
      case AttributeType.Date:
        return value.dateValue ? value.dateValue : undefined;
      case AttributeType.SingleSelect:
        const selected = picklistDefinitions.filter((x: any) => {
          return x.id === value.selectedValue;
        });
        return selected.length !== 0 ? selected[0].name : undefined;
      case AttributeType.MutliSelect:
        const multiSelected = picklistDefinitions.filter((x: any) => {
          return value.selectedValues.includes(x.id);
        });

        return multiSelected.length !== 0
          ? multiSelected.map((x: any) => x.name).join()
          : undefined;
      case AttributeType.Currency:
        return value.amount || value.amount === 0 ? value.amount : undefined;
      case AttributeType.Document:
        return value.displayName ? value.displayName : undefined;
      default:
        return undefined;
    }
  };
  return (
    <>
      {attributeValue &&
      (!showAttributesWithValue ||
        returnValue(
          attributeValue?.[index]?.value?.attributeType,
          attributeValue?.[index]?.value,
          attributeValue?.[index]?.picklistDefinitions
        )) ? (
        <div className="motif-col-md-4 custom-attribute-value ">
          <MotifLabel
            aria-label="Input"
            for="input"
            style={{ position: "relative" }}
          >
            {customAttributeDetails.name}
            {customAttributeDetails.isRequired && (
              <span className="required-input">*</span>
            )}

            {customAttributeDetails.description ? (
              <CommonTooltipWrapper
                tooltipTitle={customAttributeDetails.description || ""}
              >
                <img
                  className="attImageCon"
                  alt="tooltipimg"
                  src={helpCircleImg}
                />
              </CommonTooltipWrapper>
            ) : (
              <></>
            )}
          </MotifLabel>
          <MotifFormField aria-label="Input" role="group">
            {stopAutoFilling()}
            {renderField()}
            {attributeValue?.[index]?.value?.textValue &&
              customAttributeDetails?.metadataJSON?.format ===
                CustomAttributeFormats.Regex &&
              !handleRegexValidation(
                attributeValue?.[index]?.value?.textValue?.toString(),
                customAttributeDetails?.metadataJSON?.regexPattern
              ) && (
                <div className="motif-row align-items-center mar-l-2 ">
                  <MotifErrorMessage id="error" aria-label="Error Message">
                    {customAttributeDetails?.metadataJSON?.warningMessage}
                  </MotifErrorMessage>
                </div>
              )}
            {!valid && (
              <MotifErrorMessage id="error" aria-label="Error Message">
                {errorMessage}
              </MotifErrorMessage>
            )}
            {valid && errorFields?.includes(customAttributeDetails.name) && (
              <MotifErrorMessage id="error" aria-label="Error Message">
                {customAttributeDetails.name +
                  " " +
                  t("pages.configuration.attributes.requiredError")}
              </MotifErrorMessage>
            )}
          </MotifFormField>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
